import UserConfiguration from './UserConfiguration';


export default UserConfiguration;
